export interface TabItem {
  value: string;
  label: string;
  /** > 0 ise sekme etiketinin yanında küçük sayı rozeti gösterilir. */
  badge?: number;
}

interface TabsProps {
  items: TabItem[];
  value: string;
  onChange: (value: string) => void;
}

/**
 * Sekme çubuğu (Entegrasyonlar ekranı §1a).
 *
 * WAI-ARIA "Tabs" deseni, roving tabindex: yalnız seçili sekme `tabIndex=0`, diğerleri `-1` —
 * Tab tuşu çubuğa BİR KEZ girer, ok tuşları içeride gezinir ve anında seçimi değiştirir
 * (manuel aktivasyon değil).
 */
export function Tabs({ items, value, onChange }: TabsProps) {
  const focusTab = (targetValue: string) => {
    const el = document.querySelector<HTMLButtonElement>(
      `[role="tab"][data-tab-value="${targetValue}"]`,
    );
    el?.focus();
  };

  const moveFocus = (fromIndex: number, delta: number) => {
    const count = items.length;
    if (count === 0) return;
    const next = items[(fromIndex + delta + count) % count];
    if (!next) return;
    onChange(next.value);
    focusTab(next.value);
  };

  return (
    <div className="tabs" role="tablist">
      {items.map((item, index) => {
        const selected = item.value === value;
        return (
          <button
            key={item.value}
            type="button"
            role="tab"
            data-tab-value={item.value}
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            className={selected ? 'tabs__tab tabs__tab--active' : 'tabs__tab'}
            onClick={() => onChange(item.value)}
            onKeyDown={(e) => {
              if (e.key === 'ArrowRight') {
                e.preventDefault();
                moveFocus(index, 1);
              } else if (e.key === 'ArrowLeft') {
                e.preventDefault();
                moveFocus(index, -1);
              }
            }}
          >
            {item.label}
            {item.badge && item.badge > 0 ? (
              <span className="tabs__badge">{item.badge}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
